import { render, staticRenderFns } from "./AccessibilityMain.vue?vue&type=template&id=49243c2e&scoped=true"
import script from "./AccessibilityMain.vue?vue&type=script&lang=js"
export * from "./AccessibilityMain.vue?vue&type=script&lang=js"
import style0 from "./AccessibilityMain.vue?vue&type=style&index=0&id=49243c2e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49243c2e",
  null
  
)

export default component.exports